import {Link} from '../../link';
import styles from './drawer-menu.module.css';
import {
  categoryLinkList,
  facebookLinkList,
  recommendLinkList,
  twitterLinkList,
} from './const';
import {
  type PrtimesInformation,
  PrtimesInformationSection,
} from './prtimes-information-section';

type Props = {
  readonly informationList?: PrtimesInformation[];
};

export function DrawerMenu({informationList}: Props) {
  return (
    <>
      <ul className={styles.menuList}>
        {categoryLinkList.map((item) => (
          <li key={item.name} className={styles.menuItem}>
            <Link to={item.to} className={styles.customLink}>
              {item.name}
            </Link>
          </li>
        ))}
      </ul>
      <ul className={styles.menuList}>
        <li className={styles.actionItem}>
          <Link to='/user_info/' className={styles.customLink}>
            リリースを受信する
          </Link>
        </li>
        <li className={styles.actionItem}>
          <Link to='/service/' className={styles.customLink}>
            リリース配信お申し込み
          </Link>
        </li>
      </ul>
      <ul className={styles.menuList}>
        {facebookLinkList.map((item) => (
          <li key={item.name} className={styles.menuItem}>
            <Link isExternal to={item.to} className={styles.customLink}>
              {item.name}
            </Link>
          </li>
        ))}
      </ul>
      <ul className={styles.menuList}>
        {twitterLinkList.map((item) => (
          <li key={item.name} className={styles.menuItem}>
            <Link isExternal to={item.to} className={styles.customLink}>
              {item.name}
            </Link>
          </li>
        ))}
      </ul>
      <PrtimesInformationSection informationList={informationList} />
      <ul className={styles.recommendList}>
        <li className={styles.recommendTitle}>レコメンドサービス</li>
        {recommendLinkList.map((item) => (
          <li key={item.name} className={styles.recommendItem}>
            <Link isExternal to={item.to} className={styles.customLink}>
              {item.name}
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
}
